<template>
	<div class="animated fadeIn">

		<div class="row mb10">
			<div class="col-xs-12 clearfix">

				<div class="pull-left f24">
					<i class="fa fa-fire text-success"></i>
					<span>轮播图列表</span>
				</div>
				<div class="pull-right">
					<button class="btn btn-primary" @click.stop.prevent="$router.push('/cgd/by/carousel/create')">
						<i class="fa fa-send"></i>
						<span>创建轮播图</span>
					</button>
				</div>
			</div>
		</div>

		<div class="row">

			<div class="col-xs-12">
				<NbFilter :pager="pager" :callback="search"></NbFilter>
			</div>

			<div class="col-xs-12">
				<div v-for="carousel in pager.carousels" class="bg-white p10 mt10 border-radius-4">

					<div class="row">

						<div class="col-sm-4">
							<img class="img-rounded wp100" v-if="carousel.image && carousel.image.url" :src="carousel.image.url">
						</div>
						<div class="col-sm-8">
							<div class="media">
								<div class="pull-left">

								</div>
								<div class="pull-right action-buttons mt2">
									<a title="激活" v-show="carousel.status === 'DISABLED'" @click.stop.prevent="unlock(carousel)">
										<i class="fa fa-unlock text-primary f20"></i>
									</a>
									<a title="关闭" v-show="carousel.status === 'OK'" @click.stop.prevent="lock(carousel)">
										<i class="fa fa-lock text-warning f20"></i>
									</a>
									<a title="编辑" @click.stop.prevent="$router.push('/cgd/by/carousel/edit/'+carousel.id)">
										<i class="fa fa-pencil text-info f20"></i>
									</a>
									<a href="javascript:void(0)" title="删除" @click.stop.prevent="confirmDel(carousel)">
										<i class="fa fa-trash text-danger f20"></i>
									</a>
								</div>
								<div class="media-body">
									<div>

										<span class="label" :class="'label-'+carousel.StatusMap[carousel.status].style">{{carousel.StatusMap[carousel.status].name}}</span>

										<span class="f15">{{carousel.name}}</span>

									</div>

									<div class="mv10">
										<span v-show="carousel.showName">
											<i class="fa fa-check-square-o"></i>
											图片下方显示标题
										</span>
										<span v-show="!carousel.showName">
											<i class="fa fa-square-o"></i>
											图片下方不显示标题
										</span>


									</div>
									<div class="mv10">
										链接地址：
										<a :href="carousel.url" target="_blank">
											{{carousel.url}}
										</a>
									</div>
									<span class="mr10">#{{carousel.id}}</span>
									<span class="mr10">创建于 : {{carousel.createTime | simpleDate}}</span>
								</div>
							</div>
						</div>

					</div>


				</div>

			</div>


			<div class="col-xs-12 mt20">
				<NbPager :pager="pager" :callback="refresh"></NbPager>
			</div>

		</div>


	</div>

</template>
<script>

	import NbFilter from '../../../common/widget/filter/NbFilter.vue'
	import NbPager from '../../../common/widget/NbPager.vue'
	import {MessageBox, Notification} from 'element-ui'

	import Pager from  "../../../common/model/base/Pager"
	import Carousel from  "../../../common/model/carousel/Carousel"

	export default {

		data () {
			return {
				pager: new Pager(Carousel)
			}
		},
		components: {
			NbFilter,
			NbPager
		},
		computed: {},
		watch: {},
		methods: {
			unlock(carousel){
				carousel.httpStatus(carousel.Status.OK, function () {
					carousel.status = carousel.Status.OK;
				});
			},
			lock(carousel){
				carousel.httpStatus(carousel.Status.DISABLED, function () {
					carousel.status = carousel.Status.DISABLED;
				});
			},
			search(){
				this.pager.page = 0;
				this.refresh()
			},
			refresh(){
				this.pager.httpFastPage();
			},
			confirmDel(carousel){
				let that = this;
				MessageBox.confirm('此操作将永久删除该轮播图, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function () {
						that.fetchDel(carousel);
					},
					function () {

					}
				);
			},
			fetchDel(carousel){

				let that = this;

				carousel.httpDel(function () {
					Notification.success({
						message: '成功删除轮播图!'
					});
					that.refresh();
				});
			}
		},
		mounted(){
			this.pager.enableHistory();
			this.refresh();
		}
	}

</script>



// WEBPACK FOOTER //
// List.vue?765c9dfe